const isTeamChatId = id => id.startsWith('s-tt-');

export default isTeamChatId;
